import styled from 'styled-components';
import { Stack } from '@karma/components';
import { getColor } from '@karma/components/colors';

export const CouponsWrapper = styled(Stack)`
  max-width: 100%;
  min-width: 100%;
  width: 100%;

  .swiper-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const LoaderWrapper = styled(Stack)`
  position: relative;
  width: 100%;
  height: 400px;
`;

export const StoreInfoMessage = styled(Stack)`
  width: 478px;
  padding: 8px 20px 8px 8px;
  margin: 28px auto 0;
  gap: 8px;
  border-radius: 5px;
  background: ${getColor('shades11')};
`;
